<template>
    <div class="result-search selectors flight-select osago-issue-page"
         v-if="$store.state.tourismStore.searchTourismParams">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="navsteps">
                        <div class="navsteps__item">
                            <div class="number">1</div>
                            <div class="descr">Розрахунок</div>
                        </div>
                        <div class="navsteps__item active">
                            <div class="number">2</div>
                            <div class="descr">Вибір СК</div>
                        </div>
                        <div class="navsteps__item">
                            <div class="number">3</div>
                            <div class="descr">Оформлення</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div>
                        <button class="tourism-searchpanel" @click="showTourismSearchForm = !showTourismSearchForm">
                            <span>Параметри пошуку</span>
                            <svg :class="{'arrowUp': showTourismSearchForm}" width="11" height="6" viewBox="0 0 11 6"
                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.2795 2.75059e-08L11 0.69496L5.5 6L-2.31891e-07 0.694961L0.7205 4.45343e-07L5.50275 4.61273L10.2795 2.75059e-08Z"
                                    fill="black"/>
                            </svg>
                        </button>
                        <transition name="transition-search-form">
                            <div v-if="showTourismSearchForm">
<!--                              :dataYearProgram="$store.state.tourismStore.searchTourismParams.yearProgram"-->
                                <TourismSearchForm/>
<!--                              :dataCountry="$store.state.tourismStore.searchTourismParams.country"-->
<!--                              :dataStart="$store.state.tourismStore.searchTourismParams.date"-->
<!--                              :dataPeriodOption="$store.state.tourismStore.searchTourismParams.days"-->
<!--                              :dataEnd="$store.state.tourismStore.searchTourismParams.end"-->
<!--                              :dataMultiVisa="$store.state.tourismStore.searchTourismParams.multiVisa"-->
<!--                              :dataHumans="$store.state.tourismStore.searchTourismParams.humans"-->
<!--                              :dataFilters="$store.state.tourismStore.searchTourismParams.filters"-->
<!--                              :dataBirthDates="$store.state.tourismStore.searchTourismParams.birthDates"-->
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            <div class="row flex-lg-row-reverse ">
                <div class="col-lg-4">
                    <div class="sticky-wrapp">
                        <ClientPropositionInfo
                            :is-mobile="isMobile"
                            :proposition-list="clientPropositionsList"
                            :showPropositionModal="showPropositionModal"
                            @clear-propositions="clearPropositions()"
                            @remove-proposition="removeClientProposition"
                            :product-type="5"
                            :search-params-data="$store.state.tourismStore.searchTourismParams"
                            :date-info-data="null"
                        />
                        <TourismPolicy :dataStep="step" @searchcollapse="updateparent"/>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="osago-filters__wrapp">
                        <div :class="['filter-content-wrapp d-block', {'active': activeClassWrapp}]">

                            <div class="filter-content-wrapp__heading"><span>Фільтр</span>
                                <button class="filter-content-close" @click="filterStatusWrapp();"></button>
                            </div>

                            <div class="row flex">
                                <div class="col-lg-4">
                                    <div class="form-group w-100">
                                        <label class="form-title">Страхова сума € </label>
                                        <multiselect
                                            v-model="sortFilters.limits"
                                            :class="['form-control', 'tourism-search-custom-select']"
                                            :options="limits"
                                            :allow-empty="true"
                                            :searchable="false"
                                            :close-on-select="false"
                                            :multiple="true"
                                            placeholder=""
                                            :loading="true"
                                            label="id"
                                            track-by="id"
                                        >
                                            <template slot="selection" slot-scope="{ values }">
                                                <span v-if="values.length > 0 && values.length < 2">{{
                                                        values[0].name
                                                    }}</span>
                                                <span v-else-if="values.length > 1">Вибрано: {{ values.length }}</span>
                                                <span class="tourism-search-custom-select-placeholder" v-else>Оберіть cтрахову суму</span>
                                            </template>
                                            <template slot="option" slot-scope="{ option }">
                                                <span>{{ option.name }} $/€</span>
                                                <label
                                                    :class="{'fake_checkbox': true, 'checked': is_checkedLimits(option) }">
                                                    <i class="fa fa-check"></i>
                                                </label>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group w-100">
                                        <label class="form-title">Франшиза</label>
                                        <multiselect
                                            :class="['form-control', 'tourism-search-custom-select']"
                                            v-model="sortFilters.franchises"
                                            :options="franchises"

                                            :allow-empty="true"
                                            :searchable="false"
                                            :multiple="true"
                                            :internal-search="false"
                                            :loading="true"
                                            placeholder=""
                                            label="id"
                                            track-by="id"
                                        >

                                            <template slot="selection" slot-scope="{ values }">
                                                <span v-if="values.length > 0 && values.length < 2">{{
                                                        values[0].name
                                                    }}</span>
                                                <span v-else-if="values.length > 1">Вибрано: {{ values.length }}</span>
                                                <span class="tourism-search-custom-select-placeholder" v-else>Оберіть франшизу</span>
                                            </template>
                                            <template slot="option" slot-scope="{ option }">
                                                <span>{{ option.name }} $/€.</span>
                                                <label
                                                    :class="{'fake_checkbox': true, 'checked': is_checkedFranchises(option) }">
                                                    <i class="fa fa-check"></i>
                                                </label>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group w-100">
                                        <label class="form-title">Мета поїздки</label>
                                        <multiselect
                                            :class="['form-control', 'tourism-search-custom-select']"
                                            v-model="sortFilters.purposeOfTrip"
                                            :options="purposeOfTrip"
                                            placeholder=""
                                            :internal-search="false"
                                            :max-height="165"
                                            :options-limit="300"
                                            @select="purposeOfTripOptionSelected"
                                            :allow-empty="false"
                                            label="name">
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group w-100">
                                        <label class="form-title">Опції</label>
                                        <multiselect
                                            v-model="sortFilters.programs"
                                            :class="['form-control', 'tourism-search-custom-select']"
                                            :options="programs"
                                            :allow-empty="true"
                                            :searchable="false"
                                            :close-on-select="false"
                                            :multiple="true"
                                            placeholder=""
                                            :loading="true"
                                            label="code"
                                            track-by="code"
                                        >
                                            <template slot="selection" slot-scope="{ values }">
                                                <span
                                                    v-if="values.length > 0 && values.length < 2">{{ values[0].description }}</span>
                                                <span v-else-if="values.length > 1">Вибрано: {{ values.length }}</span>
                                                <span class="tourism-search-custom-select-placeholder" v-else>Оберіть опції</span>
                                            </template>
                                            <template slot="option" slot-scope="{ option }">
                                                <span>{{ option.description }}</span>
                                                <label
                                                    :class="{'fake_checkbox': true, 'checked': is_checkedProgram(option) }">
                                                    <i class="fa fa-check"></i>
                                                </label>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group w-100">
                                        <label class="form-title">Компанії</label>
                                        <multiselect
                                            v-model="sortFilters.companies"
                                            :class="['form-control', 'tourism-search-custom-select']"
                                            :options="companies"
                                            :allow-empty="true"
                                            :searchable="false"
                                            :close-on-select="false"
                                            :multiple="true"
                                            placeholder=""
                                            :loading="true"
                                            label="name"
                                            track-by="id"
                                        >
                                            <template slot="selection" slot-scope="{ values }">
                                                <span v-if="values.length > 0 && values.length < 2">{{
                                                        values[0].name
                                                    }}</span>
                                                <span v-else-if="values.length > 1">Вибрано: {{ values.length }}</span>
                                                <span class="tourism-search-custom-select-placeholder" v-else>Оберіть компанію</span>
                                            </template>
                                            <template slot="option" slot-scope="{ option }">
                                                <span>{{ option.name }}</span>
                                                <label
                                                    :class="{'fake_checkbox': true, 'checked': is_checkedCompany(option) }">
                                                    <i class="fa fa-check"></i>
                                                </label>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>

                                <button class="filter-content-apply" @click="filterStatusWrapp();">Застосувати</button>
                                <button class="filter-content-discard" @click="filterDiscard(); filterStatusWrapp();">
                                    Скинути фільтр
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="osago-filters__toggle">
                        <button class="osago-filters__mobToggle__item" @click="filterStatusWrapp()">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect y="1.25" width="20" height="2.5" rx="1.25" fill="#007BBB"></rect>
                                <rect y="8.75" width="20" height="2.5" rx="1.25" fill="#007BBB"></rect>
                                <rect y="16.25" width="20" height="2.5" rx="1.25" fill="#007BBB"></rect>
                                <rect x="13.25" y="0.75" width="3.5" height="3.5" rx="1.25" fill="white"
                                      stroke="#007BBB" stroke-width="1.5"></rect>
                                <rect x="12" y="15.75" width="3.5" height="3.5" rx="1.25" fill="white"
                                      stroke="#007BBB" stroke-width="1.5"></rect>
                                <rect x="4.5" y="8.25" width="3.5" height="3.5" rx="1.25" fill="white"
                                      stroke="#007BBB" stroke-width="1.5"></rect>
                            </svg>
                            Фільтр
                        </button>
                        <div class="row align-items-center osago-sort-select">
                            <div v-if="!$store.getters.USER.organizationId" class="osago-offers__earnings">
                                <button v-if="!showEarnings" @click="showEarnings = true" type="button">
                                    <svg style="margin-bottom: 5px" width="16" height="16"
                                         viewBox="0 0 16 16" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0)">
                                            <path
                                                d="M0.666504 8C0.666504 8 3.33317 2.66667 7.99984 2.66667C12.6665 2.66667 15.3332 8 15.3332 8C15.3332 8 12.6665 13.3333 7.99984 13.3333C3.33317 13.3333 0.666504 8 0.666504 8Z"
                                                stroke="#24282C" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round"/>
                                            <path
                                                d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                                                stroke="#24282C" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0">
                                                <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span>Показати заробіток</span>
                                </button>
                                <button v-if="showEarnings" @click="showEarnings = false" type="button">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9.11649 5.0665C9.4088 5.02169 9.70411 4.9994 9.99983 4.99983C12.6498 4.99983 15.1415 6.90816 16.5915 9.99983C16.3697 10.4703 16.1193 10.9267 15.8415 11.3665C15.7533 11.503 15.707 11.6623 15.7082 11.8248C15.71 12.0067 15.7713 12.183 15.8827 12.3267C15.9941 12.4705 16.1495 12.5739 16.3251 12.6211C16.5008 12.6683 16.687 12.6568 16.8555 12.5882C17.024 12.5197 17.1654 12.3979 17.2582 12.2415C17.6464 11.6314 17.9837 10.9904 18.2665 10.3248C18.3112 10.2208 18.3343 10.1088 18.3343 9.99566C18.3343 9.88248 18.3112 9.77048 18.2665 9.6665C16.5832 5.75816 13.4165 3.33316 9.99983 3.33316C9.60872 3.33119 9.21823 3.36466 8.83316 3.43316C8.72373 3.45177 8.61903 3.49174 8.52504 3.55081C8.43106 3.60988 8.34963 3.68688 8.2854 3.77741C8.22117 3.86795 8.17541 3.97025 8.15072 4.07848C8.12602 4.1867 8.12289 4.29873 8.1415 4.40816C8.1601 4.5176 8.20008 4.6223 8.25914 4.71628C8.31821 4.81027 8.39521 4.8917 8.48575 4.95592C8.57628 5.02015 8.67858 5.06592 8.78681 5.09061C8.89503 5.1153 9.00706 5.11843 9.11649 5.09983V5.0665ZM3.0915 1.90816C3.0138 1.83046 2.92155 1.76883 2.82004 1.72678C2.71852 1.68473 2.60971 1.66309 2.49983 1.66309C2.38995 1.66309 2.28114 1.68473 2.17962 1.72678C2.0781 1.76883 1.98586 1.83046 1.90816 1.90816C1.75124 2.06508 1.66309 2.27791 1.66309 2.49983C1.66309 2.72175 1.75124 2.93458 1.90816 3.0915L4.4915 5.6665C3.31281 6.8011 2.37471 8.16148 1.73316 9.6665C1.68728 9.77163 1.66359 9.88511 1.66359 9.99983C1.66359 10.1145 1.68728 10.228 1.73316 10.3332C3.4165 14.2415 6.58316 16.6665 9.99983 16.6665C11.4974 16.6561 12.9596 16.2102 14.2082 15.3832L16.9082 18.0915C16.9856 18.1696 17.0778 18.2316 17.1793 18.2739C17.2809 18.3162 17.3898 18.338 17.4998 18.338C17.6098 18.338 17.7188 18.3162 17.8203 18.2739C17.9219 18.2316 18.014 18.1696 18.0915 18.0915C18.1696 18.014 18.2316 17.9219 18.2739 17.8203C18.3162 17.7188 18.338 17.6098 18.338 17.4998C18.338 17.3898 18.3162 17.2809 18.2739 17.1793C18.2316 17.0778 18.1696 16.9856 18.0915 16.9082L3.0915 1.90816ZM8.39149 9.56649L10.4332 11.6082C10.2923 11.6486 10.1463 11.6682 9.99983 11.6665C9.5578 11.6665 9.13388 11.4909 8.82132 11.1783C8.50876 10.8658 8.33316 10.4419 8.33316 9.99983C8.33146 9.85332 8.35111 9.70734 8.39149 9.56649ZM9.99983 14.9998C7.34983 14.9998 4.85816 13.0915 3.4165 9.99983C3.9549 8.81129 4.71906 7.73864 5.6665 6.8415L7.1415 8.33316C6.79503 8.96549 6.66295 9.69312 6.76504 10.4069C6.86714 11.1206 7.19793 11.782 7.70777 12.2919C8.21761 12.8017 8.87902 13.1325 9.59278 13.2346C10.3065 13.3367 11.0342 13.2046 11.6665 12.8582L12.9915 14.1665C12.0841 14.7006 11.0527 14.9879 9.99983 14.9998Z"
                                            fill="#24282C"/>
                                    </svg>
                                    Сховати заробіток
                                </button>
                            </div>
                            <div class="d-flex osago-sort-select__content">
                                <p class="sort-type ml-lg-auto" @click="setOffersSortType">
                                    <span class="osago-sort-select__descr">Сортування:</span>
                                    <span class="osago-sort-select__toggleMob">
                              <svg width="20" height="18" viewBox="0 0 20 18" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                 <rect y="0.25" width="20" height="2.5" rx="1.25" fill="#007BBB"></rect>
                                 <rect y="7.75" width="16" height="2.5" rx="1.25" fill="#007BBB"></rect>
                                 <rect y="15.25" width="12" height="2.5" rx="1.25" fill="#007BBB"></rect>
                              </svg>
                              Сортування
                           </span>
                                    <select class="nice-select sort-select" v-model="sortFilters.type">
                                        <option value="price-earnings" data-display="Найвигідніші">
                                            <div class="d-flex justify-content-between">
                                                <i class="icon  pin save-default"></i>
                                                <span>Найвигідніші</span>
                                            </div>
                                        </option>
                                        <option value="lowcost" data-display="Найдешевші">
                                            <div class="d-flex justify-content-between">
                                                <i class="icon  pin save-default"></i>
                                                Найдешевші
                                            </div>
                                        </option>
                                        <option value="earnings" data-display="За заробітком">
                                            <div class="d-flex justify-content-between">
                                                <i class="icon  pin save-default"></i>
                                                За заробітком
                                            </div>
                                        </option>
                                        <option value="name" data-display="За назвою компанії">
                                            <div class="d-flex justify-content-between">
                                                <i class="icon  pin save-default"></i>
                                                За назвою компанії
                                            </div>
                                        </option>
                                        <option value="net-pay" data-display="За нетто-платежем">
                                            <div class="d-flex justify-content-between">
                                                <i class="icon  pin save-default"></i>
                                                За нетто-платежем
                                            </div>
                                        </option>
                                    </select>
                                </p>
                            </div>
                            <div class="osago-sort-view">
                                <span>Вид:</span>
                                <button class="toggler-view-second" @click="viewSecondAdd('result-second')">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <rect width="8" height="8" rx="2" fill="#999DA6"/>
                                        <rect x="10" width="8" height="8" rx="2" fill="#999DA6"/>
                                        <rect x="10" y="10" width="8" height="8" rx="2" fill="#999DA6"/>
                                        <rect y="10" width="8" height="8" rx="2" fill="#999DA6"/>
                                    </svg>
                                </button>
                                <button class="toggler-view-default active"
                                        @click="viewSecondRemove('result-second')">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <line x1="8.74229e-08" y1="1" x2="18" y2="1" stroke="#999DA6"
                                              stroke-width="2"/>
                                        <line x1="8.74229e-08" y1="9" x2="18" y2="9" stroke="#999DA6"
                                              stroke-width="2"/>
                                        <line x1="8.74229e-08" y1="17" x2="18" y2="17" stroke="#999DA6"
                                              stroke-width="2"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="row flex ">
                        <div class="col-lg-4 position-relative results" v-if="variants">
                            <div class="results-fixed-header">
                                <div class="osago-offers__heading">
                                    <div class="osago-offers__title">
                                        <h3>Знайдено: {{ variants.length }}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 position-relative results" v-if="loadingFlag">
                        <div class="results_anime">
                            <div class="results_anime_circles">
                                <div class="waiting_animation">
                                    <div class="background">
                                        <div class="loader loader-left"></div>
                                        <div class="loader loader-right"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="results_anime_percent">
                                <span class="results_anime_percent-text"></span>
                            </div>
                            <div class="results_anime_line">
                                <span class="results_anime_line-scale" :style="`width: 1%;`"></span>
                            </div>
                        </div>
                    </div>

                    <div v-if="variants.length" class="result-list new-list flight-list">
                        <div class="result-article" v-for="(company, index) in variants" :key="index">
                            <div class="result-article__wrapp">
                                <div class="result-item result-item-rated">
                                    <div class="result-wrapp">
                                        <div class="result__info">
                                            <div class="result__logo">
                                                <img v-if="company.company.logo" :src="company.company.logo" alt="logo">
                                                <img v-else src="images/aboutUs-insurance_icon.svg" alt="logo">
                                            </div>
                                            <div class="result__info__main">
                                                <div class="result__name">
                                                    <h5>{{ company.company.publicName }}</h5>
                                                    <span data-placement="bottom" data-toggle="tooltip" title=""
                                                          class="mtsbu-icon"
                                                          data-original-title="<div class=&quot;mtsbu-rating__heading&quot;><span>Рейтинг</span><img src=&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAMCAYAAAA5xADKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAh8SURBVHgBlVYLUFTnFT73uffuCxZ2AQkoCigi1abGR0xIxWjBpFXb1DhpR5tIsLEZzFitbVrHbGPS2NaatJVMEuvU6YyOolVAGyUaERUTUXwFX4CACizLc9nnvXtf/f+7LBLEzOTfObP//c85//+f75zv3EtYK1at8cv+RANB9IFGEPAthgxad1x6/gH3tBWBJ+v/FXfl5omVQFKaw5p66N6CLc1RO03TCKqiqMigCFbeknB2vG1SXV1znRHMBu2Rm4sUOXfJYv8pIk9Orn4ntaP/dq5BgTGqGgqx8ZNr/HlvXyPQde3lfzb3MG0P39svEhnmHKGJaedACkbOWRjvB8KpDtlcXW+CdpHCU7uV1+ik5Il7GpvPXAmpymPwbYemQXfjYQuabb/jqp8bkgb+CkBAQI7vQWtDYJgOryxUQ10fhTQgNGNcUacSJEDpOA4+evR9CXoALCnFt09Wt8L+n/6xw1W7AEA1iINqyX1ZMR0pfMfpdL79rvLVKRD8k0a5W0iNzZpHdbbtVKRANloA8wl+hR/gIFbP+vIf1guNZ6tVJZwJmgoCpPyObHhifY9msC8jaFM9qgwFBxgRGBRiFBlcR7HxDO9ZWlpKefrvFQKJgiNIlBT/lOid7OUrJ4WEgfcASN1RIJj2kK83BjTZCCoSTTENilFf0xTNZEoujFPDQVf3pVOgiD9ElzXg8gIV/fQca5SJ5lu2z49PkkRv9gN/aUgYhru94snHb5oI4mJEr5pE//3cCE4aca3z4kZVCnwX3cEEDF/tW1hSEknN4p01c27tnFPTfGXKeJLN7FBEuygFYkGVEHvICRRJxA4BruJ4KT86gFXD/nHPxn+/vHzgdHbYJz0bySoBhDwwDk+d9aXs5oay9zVVskf940zJ/XZOa+oLJM4F2pwEvnt7sRfFWi4oYNoARrYHFCLZ47u3Hy1b0M1VgrEcYk3xO0TQvGZJWOAPutdPc0ytqum9gYJTOAQ0kKz1Y5Xl90TPsfG2DieiGHt8Laocz2p8L1mWn3BqVbSt8o3cUKhnLToVLVMN8Y6pryLKaUN1enbzuZng6XPDooL/Ass+4FVaGrR1d3+NkykTJsjE9OnypNPb0yqeLvQZK15+IwxgiOpJYDIx+uayFcWK6MuHqDdBarPj0lyfZr+AaXSar/z1shCKVQeQYith8Y7q4sZGQ8nlDaUqEDGIGhrJ2d/ctOTlbTgwvAUq8y8eq1zXuWq6rf1sWe88XIk4Qymx6QfWp86uLc5YGMaBdQ0emRyTcbq1946AjDhNk7+z9Vx1VqD/7ofoQBoBHXbEpr3e9cwfXNj2AWkp5hZ8UVsDX16IifBgWPAwYjAGn5aTuZo4Ufm/MWd+O9bVfuOl4eqgIiZPPbd1diDsfQsBQQ4pCMpL93n6oo9yyF2gBwOEYuDjqnG0e5u3L0E8nozXadLw6cYluxAQhDx8//b8v31y4mKFUVGkZwZBhnvuurI17kvSumu7GhOOFm3qWrijEqtaZ77eSR5YdkuVg5gSVsHdsE8DOQuFqBmMjje7Cj448SCJ0Xv+56N2yMwqQtRWEPdjv1EUORXudz2O/dw97lfQn1HHj2IGd1Piv+o4X46oZMGlGAkYdw1WuJEYCOP53JYqjpTDMyMYsZ0OJrUOzz1e12JkT6D+AUkxY0tGAhEduz2XMiTJn64/YO5qmhlVmE2SQjO7B1z7cmpLUmEoz8bPo2HKYV82bvIUay5flJ62ffie5PAH4vznx6Hgx98Dq3UT8Nxu4Az7viYWy2GIsV4GRfVC/vx96ZXOBJC8q/QDaUNzMmcvGWzANGp8Djy3GeN30JTBFbFhXU0ZxToYF1vOpIuKoAdDktTV1ry1HjxHTWpyJECAJC61cyQIS+tLzU4NsUd05yIbHX2Ws22yx2f9CEimIYKNElPfezM76sPwlpM6YIODJuhGc8KilftznOHhez/0bptfPIuufcVa6mPDHSN1jthxWtcNRwj2lj0Ff/9LU9vhV1eriBIoI1os59g2IIcCiOc47Ai4tLG235D6IQQvL8fPEmgubIvnfMg106+itwTKkomxHPdGE0JoQmRCwnXP1TwE6BXdB/WgMad+P+lYc+W6pVOWvhYK+wsQijhyyWHP3tduy2ilfG3tiipNRPZSgjmlM9o3WCauI0jeRZ9FKo3al5eOG180kPvz/pHxPQQGZehwi21NBxEVskbqul0tYTMf96fAwT3/zr6+hJWEgdd0CpCMS2QT93OcMDUg9siRfdXwWEvC6oDqIXtU2YCLkKX53mgq/HJwsF+AIjDMyegZKsFWgxacjXWhYN8Wqmz5LP5wUUPw4EsTXLKQz/EJH1/sqTGGRO8c3YGkBY+3tRBcdTmKFtZfnTRjrNmYNPXWGpzAqhJzd3/1PxFlaVyyBG9/V/jB+9UwyiBHLnw27TcBkk/7JYE6LcjiWFTuw0TIEMK+57Fdy/3qn6iqqJciY7CU+vOdXQnGlEaU0hCmRwzneOtuQcmlgBZO09+3qKaNJNOC7ZdfrTQJoneuDj7JtixOzRn6QDObMrahRu8aLBNGEQde9Adc+JvgZ+hVHxdvTDyy+9qxGZom2XQbTbUEfB0bEPbPoaKkSYJsHZ+YU7gm8zkR00n01r4H4eDTuAKtrG3PC+nPfwCPGORoi8LCLa0TYsY/RTLcFoY2nweKbwKSv8Ohj5MYPvaTqqoqmtPkOVba+JmVMh7NSJ2hH5CXOaWXIaggQXPnbdN+oa8xQVG0MqajWGJJ+jpeuyLfybKQdB3yP5rI23aXTvlVIHq2G4FqtozJo2jTEVQdQfxhhzqsjOY9Bi72UFH6vMuM5J1oZSzHsH9ETEfNFFdBc5bNpvTcGY25Th3cXWe3zgBJSMd6JEfYtLwN+3NeDD8KjP8DPmveZ7IAIk4AAAAASUVORK5CYII=&quot; alt=&quot;МТСБУ&quot;><i data-placement=&quot;bottom&quot; data-toggle=&quot;tooltip&quot; title=&quot;&quot; class=&quot;icon question&quot; data-original-title=&quot;На основі квартального звіту МТСБУ по ОСЦПВ&quot;></i><p>На основі квартального звіту МТСБУ по ОСЦПВ</p></div><ul class=&quot;mtsbu-rating__list&quot;><li class=&quot;mtsbu-rating__item&quot;><span class=&quot;mtsbu-rating__name&quot;>Загальна оцінка</span><!----><!----><span class=&quot;mtsbu-rating__value rating-good&quot;><span>Добре</span></span></li><li class=&quot;mtsbu-rating__item&quot;><span class=&quot;mtsbu-rating__name&quot;>Качество урегулирования</span><!----><!----><span class=&quot;mtsbu-rating__value rating-good&quot;><span>Добре</span></span></li><li class=&quot;mtsbu-rating__item&quot;><span class=&quot;mtsbu-rating__name&quot;>Уровень жалоб</span><!----><!----><span class=&quot;mtsbu-rating__value rating-good&quot;><span>Добре</span></span></li></ul><div class=&quot;mtsbu-rating__deadlines&quot;><span>0 днів</span><p>швидкість виплати по ОСЦПВ</p></div>">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="8" cy="8" r="8" fill="#EF4137"></circle>
                                                    <path
                                                        d="M4.75736 11.4853L11.1213 5.12132M11.1213 5.12132H6.87868M11.1213 5.12132L11.2427 9.24256"
                                                        stroke="white" stroke-width="1.5"></path>
                                                </svg>
                                                </span>
                                                </div>
                                                <div class="result__rating">
                                                    <i v-for="stars in 5" :key="stars">
                                                        <svg v-if="Math.floor(company.company.rating) >= stars"
                                                             width="18" height="17" viewBox="0 0 18 17" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M8.99984 13.417L14.1665 16.5003L12.8332 10.667L17.3332 6.66699L11.3332 6.16699L8.99984 0.666992L6.6665 6.16699L0.666504 6.66699L5.24984 10.667L3.9165 16.5003L8.99984 13.417Z"
                                                                fill="#FA9B13"></path>
                                                        </svg>
                                                        <svg v-else width="18" height="17" viewBox="0 0 18 17"
                                                             fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M9.25607 12.9876L8.99774 12.8335L8.74053 12.9895L4.66713 15.4602L5.73727 10.7784L5.8039 10.4869L5.5786 10.2903L1.88543 7.06715L6.70803 6.66527L7.00889 6.64019L7.12679 6.36227L8.99984 1.94724L10.8729 6.36227L10.9908 6.64019L11.2916 6.66527L16.129 7.06838L12.501 10.2933L12.2798 10.4899L12.3457 10.7784L13.4185 15.4717L9.25607 12.9876Z"
                                                                stroke="#FA9B13"></path>
                                                        </svg>
                                                    </i>
                                                </div>

                                                <div class="result__department">
                                                    <a href="javascript:void(0)">
                                                        <svg width="12" height="16" viewBox="0 0 12 16" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                                  d="M8.84798 6.84758C8.84798 7.55482 8.56703 8.2331 8.06693 8.73319C7.56684 9.23329 6.88856 9.51424 6.18131 9.51424C5.47407 9.51424 4.79579 9.23329 4.2957 8.73319C3.7956 8.2331 3.51465 7.55482 3.51465 6.84758C3.51465 6.14033 3.7956 5.46205 4.2957 4.96196C4.79579 4.46186 5.47407 4.18091 6.18131 4.18091C6.88856 4.18091 7.56684 4.46186 8.06693 4.96196C8.56703 5.46205 8.84798 6.14033 8.84798 6.84758ZM7.51465 6.84758C7.51465 7.2012 7.37417 7.54034 7.12412 7.79038C6.87408 8.04043 6.53494 8.18091 6.18131 8.18091C5.82769 8.18091 5.48855 8.04043 5.23851 7.79038C4.98846 7.54034 4.84798 7.2012 4.84798 6.84758C4.84798 6.49395 4.98846 6.15481 5.23851 5.90477C5.48855 5.65472 5.82769 5.51424 6.18131 5.51424C6.53494 5.51424 6.87408 5.65472 7.12412 5.90477C7.37417 6.15481 7.51465 6.49395 7.51465 6.84758Z"
                                                                  fill="#009BEB"></path>
                                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                                  d="M1.86267 11.0119C1.00323 10.1936 0.405739 9.13884 0.14576 7.98098C-0.11422 6.82312 -0.0250142 5.61416 0.402097 4.507C0.829208 3.39983 1.57504 2.44419 2.54528 1.76091C3.51552 1.07762 4.66659 0.697397 5.85292 0.668308C7.03926 0.639218 8.20758 0.962572 9.21014 1.59748C10.2127 2.23239 11.0045 3.15033 11.4853 4.23523C11.9662 5.32013 12.1146 6.52326 11.9116 7.69248C11.7087 8.86169 11.1636 9.94447 10.3453 10.8039L6.208 15.1492L1.86267 11.0119ZM9.38 9.88457L6.162 13.2646L2.782 10.0466C2.11358 9.41012 1.64889 8.58976 1.4467 7.68922C1.24451 6.78868 1.31389 5.8484 1.64608 4.9873C1.97827 4.12619 2.55833 3.38292 3.31294 2.85148C4.06754 2.32004 4.96278 2.02429 5.88547 2.00163C6.80815 1.97898 7.71683 2.23043 8.4966 2.7242C9.27637 3.21797 9.89222 3.93188 10.2663 4.77564C10.6403 5.61941 10.7558 6.55515 10.598 7.46453C10.4403 8.37391 10.0164 9.21608 9.38 9.88457Z"
                                                                  fill="#009BEB"></path>
                                                        </svg>
                                                        <span>10 відділень</span>
                                                    </a>
                                                </div>
                                            </div>
                                          <div class="result__proposition_icon nomobile">
                                            <div class="proposition-icon-box" v-if="user && user.recipientTypeId == 4" @click="selectClientProposition($event, company)">
                                                <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_2_866)">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.26042 3.64026L8.27083 9.66026V9.80026C8.27083 10.6403 8.05208 11.6903 7.46875 12.5303C6.8125 13.4403 5.79167 14.0003 4.26042 14.0003C2.72917 14.0003 1.70833 13.4403 1.05208 12.5303C0.46875 11.6903 0.25 10.6403 0.25 9.80026V9.59026L4.26042 3.64026ZM1.78125 10.5003C1.85417 10.9203 2 11.4103 2.29167 11.7603C2.58333 12.1803 3.23958 12.6003 4.26042 12.6003C5.28125 12.6003 5.9375 12.1803 6.22917 11.7603C6.44792 11.4103 6.66667 10.9903 6.73958 10.5003H1.78125ZM6.22917 9.10026H2.29167L4.26042 6.16026L6.22917 9.10026Z" fill="#009BEB"/>
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7394 3.64026L17.7498 9.66026V9.80026C17.7498 10.6403 17.5311 11.6903 16.9478 12.5303C16.2915 13.4403 15.2707 14.0003 13.7394 14.0003C12.2082 14.0003 11.1873 13.4403 10.5311 12.5303C9.94775 11.6903 9.729 10.6403 9.729 9.80026V9.59026L13.7394 3.64026ZM11.2603 10.5003C11.3332 10.9203 11.479 11.4103 11.7707 11.7603C12.1353 12.2503 12.7186 12.6003 13.7394 12.6003C14.7603 12.6003 15.4165 12.1803 15.7082 11.7603C15.9269 11.4103 16.1457 10.9903 16.2186 10.5003H11.2603ZM15.7082 9.10026H11.8436L13.8123 6.16026L15.7082 9.10026Z" fill="#009BEB"/>
                                                        <path d="M9 0C9.51042 0 10.0208 0.28 10.2396 0.7H15.5625V2.1H10.2396C10.0208 2.52 9.51042 2.8 9 2.8C8.48958 2.8 7.97917 2.52 7.76042 2.1H2.4375V0.7H7.76042C7.97917 0.28 8.48958 0 9 0Z" fill="#009BEB"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_2_866">
                                                            <rect width="17.5" height="14" fill="white" transform="translate(0.25)"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <span v-if="clientPropositionsList.includes(company)" class="span-checked">
                                                    <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="9" cy="9" r="8" fill="#00B52C" stroke="white" stroke-width="2" />
                                                        <path d="M5 8L8 11L13 6" stroke="white" stroke-width="2" />
                                                    </svg>
                                                </span>
                                            </div>
                                            <div class="proposition-icon-box" v-if="!company.discountPrice && !isApiUser"  @click="discountSet($event, company)">
                                              <svg width="18" height="18" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <rect width="100" height="100" fill="url(#pattern0_927_2)"/>
                                                <defs>
                                                  <pattern id="pattern0_927_2" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0_927_2" transform="scale(0.01)"/>
                                                  </pattern>
                                                  <image id="image0_927_2" width="100" height="100" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                                                </defs>
                                              </svg>
                                              <modal-discount-set :id="company.offerId" :offer="company"  @update:offer="handleUpdateOffer"/>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="result__details">
                                            <div class="result__params">
                                                <div class="result__param">
                                                    <div class="descr">
                                                        <div class="heading">
                                                            <b>{{ company.name }}</b>
                                                        </div>
                                                        <span>Програма {{ getTripProgram(company.tripProgram) }}</span>
                                                        <span v-if="company.territory && company.territory.name"
                                                              class="result__territory"
                                                              :title="company.territory.name">
                                                            Територія: {{ company.territory.name }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="result__params">
                                                <div class="result__param">
                                                    <div class="heading"><span>{{ company.options.count }}</span> опцій
                                                    </div>
                                                    <div class="descr"> Включено</div>
                                                </div>
                                                <div class="result__param">
                                                    <div class="heading"><span>{{
                                                            company.franchise
                                                        }} {{ company.limit_currency | currencySign }} </span>
                                                        <i :id="'tooltip-franchise-' + index" data-placement="bottom"
                                                           data-toggle="tooltip"
                                                           title="Франшиза - це частина коштів, які страхова компанія не відшкодовує при страховому випадку."
                                                           class="icon question"></i>
                                                        <b-tooltip :target="'tooltip-franchise-' + index"
                                                                   triggers="hover">
                                                            Франшиза - це частина коштів, які страхова компанія не
                                                            відшкодовує при страховому випадку.
                                                        </b-tooltip>
                                                    </div>
                                                    <div class="descr"> Франшиза</div>
                                                </div>
                                                <div class="result__param param-percent tourism">
                                                    <div class="heading"><span>{{
                                                            company.limit
                                                        }} {{ company.limit_currency | currencySign }}</span>
                                                        <i :id="'tooltip-percent-' + index" data-placement="bottom"
                                                           data-toggle="tooltip"
                                                           title="Страхова сума — грошова сума, в межах якої страховик відповідно до умов страхування зобов'язаний провести виплату з настанням страхового випадку."
                                                           data-original-title="Подсказка страховой лимит"
                                                           class="icon question"></i></div>
                                                    <b-tooltip :target="'tooltip-percent-' + index" triggers="hover">
                                                        Страхова сума — грошова сума, в межах якої страховик відповідно
                                                        до умов страхування зобов'язаний провести виплату з настанням
                                                        страхового випадку.
                                                    </b-tooltip>
                                                    <div class="descr"> Страховий ліміт</div>
                                                </div>
                                            </div>
                                            <div class="result__options__wrapp">
                                                <div class="result__options">
                                                    <div class="heading">Рекомендуем включити:</div>
                                                    <div class="result__options__list">
                                                        <div class="result__option greey soon">
                                                            <p>Зелена карта</p>
                                                            <span class="label">Скоро</span>
                                                        </div>
                                                        <div class="result__option pink soon">
                                                            <div class="icon"></div>
                                                            <p>Страхування багажу</p>
                                                            <span class="label">Скоро</span>
                                                        </div>
                                                        <button class="params__more soon"> Ще</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="result__more"><a data-toggle="collapse"
                                                                         :data-target="'#brandMore-'+index"
                                                                         aria-expanded="false"
                                                                         :aria-controls="'brandMore-'+index"
                                                                         class="collapsed"> Детальніше про поліс <img
                                                src="/img/arrow-down.8bfc342c.svg" alt="Подробнее о полисе"></a></div>
                                        </div>

                                        <div class="result__order">
                                            <div v-if="showEarnings">
                                                <div class="result__earnings" v-if="company.discountPrice > 0">
                                                    Нетто платіж
                                                    {{
                                                        (((company.dynamicDiscountPrice > 0) ? company.dynamicDiscountPrice : company.discountPrice) - company.earnings).toFixed(2)
                                                    }} грн
                                                </div>
                                                <div class="result__earnings" v-else>
                                                    Нетто платіж
                                                    {{ (company.price - company.earnings).toFixed(2) }} грн
                                                </div>
                                            </div>

                                            <div class="result__price">
                                              <div v-if="company.dynamicDiscountedSum > 0 || company.discountPrice > 0" class="old"
                                                   data-placement="bottom" data-toggle="tooltip"
                                                   title="Знижка надається безпосередньо за наш рахунок від ціни, що надається страховою компанією. Ми забезпечуємо найнижчу ціну на ринку. Вартість поліса вказана з урахуванням знижки.">
                                                <span>{{ company.price }} <span>грн</span></span>
                                                <b v-if="company.dynamicDiscountedSum > 0">-{{ company.dynamicDiscountedSum }} грн</b>
                                                <b v-else >-{{ company.discountPercent }}%</b>
                                              </div>
                                              <div v-if="company.dynamicDiscountPrice > 0 || company.discountPrice > 0" :class="['value','red']">
                                                {{ company.dynamicDiscountPrice || company.discountPrice }} <span>грн</span>
                                              </div>
                                              <div class="value" v-else-if="company.fullPrice"> {{ company.fullPrice.toFixed(2)}} <span>грн</span></div>
                                              <div class="value" v-else> {{ company.price.toFixed(2) }} <span>грн</span></div>
                                            </div>
                                            <button v-if="!user || user.recipientTypeId != 4" class="result__submit" v-loading="concludeOffer"
                                                    @click="concludeContract(company)"> Оформити
                                            </button>
                                            <button v-else-if="user && user.recipientTypeId == 4 && clientPropositionsList.includes(company)" class="btn prop-button btn-outline-blue" v-loading="concludeOffer"
                                                    v-on:click="selectClientProposition($event, company)">
                                                Обрано
                                            </button>
                                            <button v-else-if="user && user.recipientTypeId == 4 && !clientPropositionsList.includes(company)" class="btn prop-button btn-orange" v-loading="concludeOffer"
                                                    v-on:click="selectClientProposition($event, company)">
                                                Обрати
                                            </button>
                                            <div
                                                v-if="showEarnings && (company.dynamicDiscountPrice || company.earnings)">
                                                <div class="result__earnings">
                                                    Ваш заробіток
                                                    {{ (company.dynamicDiscountPrice > 0) ? company.dynamicEarnings : company.earnings }}
                                                    грн
                                                </div>
                                                <div class="result__earnings">
                                                    ({{
                                                        Math.round(((company.dynamicDiscountPrice > 0) ? company.dynamicEarnings : company.earnings) / company.price * 100)
                                                    }}%)
                                                </div>
                                              <div class="result__earnings" v-if="!isApiUser">
                                                Мін. ціна для продажу: {{ showMinPrice(company) }} грн
                                              </div>
                                            </div>
                                        </div>
                                        <div class="result__nav mob">
                                            <a data-toggle="collapse"
                                                                         :data-target="'#brandMore-'+index"
                                                                         aria-expanded="false"
                                                                         :aria-controls="'brandMore-'+index"
                                                                         class="more collapsed"> Детальніше <img
                                            src="/img/arrow-down.8bfc342c.svg" alt="Детальніше"></a>
                                            <div class="result__proposition_icon mobile">
                                                <div class="proposition-icon-box" v-if="user && user.recipientTypeId == 4" @click="selectClientProposition($event, company)">
                                                    <svg class="vesu" width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_2_866)">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.26042 3.64026L8.27083 9.66026V9.80026C8.27083 10.6403 8.05208 11.6903 7.46875 12.5303C6.8125 13.4403 5.79167 14.0003 4.26042 14.0003C2.72917 14.0003 1.70833 13.4403 1.05208 12.5303C0.46875 11.6903 0.25 10.6403 0.25 9.80026V9.59026L4.26042 3.64026ZM1.78125 10.5003C1.85417 10.9203 2 11.4103 2.29167 11.7603C2.58333 12.1803 3.23958 12.6003 4.26042 12.6003C5.28125 12.6003 5.9375 12.1803 6.22917 11.7603C6.44792 11.4103 6.66667 10.9903 6.73958 10.5003H1.78125ZM6.22917 9.10026H2.29167L4.26042 6.16026L6.22917 9.10026Z" fill="#009BEB"/>
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7394 3.64026L17.7498 9.66026V9.80026C17.7498 10.6403 17.5311 11.6903 16.9478 12.5303C16.2915 13.4403 15.2707 14.0003 13.7394 14.0003C12.2082 14.0003 11.1873 13.4403 10.5311 12.5303C9.94775 11.6903 9.729 10.6403 9.729 9.80026V9.59026L13.7394 3.64026ZM11.2603 10.5003C11.3332 10.9203 11.479 11.4103 11.7707 11.7603C12.1353 12.2503 12.7186 12.6003 13.7394 12.6003C14.7603 12.6003 15.4165 12.1803 15.7082 11.7603C15.9269 11.4103 16.1457 10.9903 16.2186 10.5003H11.2603ZM15.7082 9.10026H11.8436L13.8123 6.16026L15.7082 9.10026Z" fill="#009BEB"/>
                                                            <path d="M9 0C9.51042 0 10.0208 0.28 10.2396 0.7H15.5625V2.1H10.2396C10.0208 2.52 9.51042 2.8 9 2.8C8.48958 2.8 7.97917 2.52 7.76042 2.1H2.4375V0.7H7.76042C7.97917 0.28 8.48958 0 9 0Z" fill="#009BEB"/>
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_2_866">
                                                                <rect width="17.5" height="14" fill="white" transform="translate(0.25)"/>
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <span v-if="clientPropositionsList.includes(company)" class="span-checked">
                                                        <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="9" cy="9" r="8" fill="#00B52C" stroke="white" stroke-width="2" />
                                                            <path d="M5 8L8 11L13 6" stroke="white" stroke-width="2" />
                                                        </svg>
                                                    </span>
                                                </div>
                                                <div class="proposition-icon-box" v-if="!company.discountPrice && !isApiUser" @click="discountSet($event, company)">
                                                    <svg width="26" height="26" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <rect width="100" height="100" fill="url(#pattern0_927_3)"/>
                                                        <defs>
                                                            <pattern id="pattern0_927_3" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                                <use xlink:href="#image0_927_3" transform="scale(0.01)"/>
                                                            </pattern>
                                                            <image id="image0_927_3" width="100" height="100" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                                                            </pattern>
                                                        </defs>
                                                    </svg>
                                                    <modal-discount-set :id="company.offerId" v-model="company.showModal" :offer="company" @update:offer="handleUpdateOffer"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div :id="'brandMore-'+index" class="row details collapse details-article-more">
                                        <div class="col-12">
                                            <div class="details__wrapp">
                                                <div class="details__heading">Загальна інформація</div>
                                                <div class="details__params__list">
                                                    <p class="company_links" v-if="company.company.companyLink">
                                                        <span>
                                                            <a target="_blank" :href="company.company.companyLink">Туристичне страхування</a>
                                                        </span>
                                                        <span>
                                                            <a v-if="company.descriptionLink"
                                                               :href="company.descriptionLink" target="_blank">Всі умови покриття</a>
                                                        </span>
                                                    </p>
                                                  <div class="details__list">
                                                      <p class="company_links">
                                                      <span v-if="company.company.docProduct">
                                                          <a target="_blank" :href="company.company.docProduct">Інформація про страховий продукт</a>
                                                      </span>
                                                        <span v-if="company.company.docCompany">
                                                      <a target="_blank" :href="company.company.docCompany">Інформація про страхову компанію</a>
                                                      </span>
                                                            <span v-if="company.company.docAgent">
                                                          <a target="_blank" :href="company.company.docAgent">Інформація про страхового посередника</a>
                                                      </span>
                                                        <span v-if="company.company.docZusp">
                                                            <a target="_blank" :href="company.company.docZusp">Інформація про загальні умови страхового продукту</a>
                                                        </span>
                                                      </p>
                                                      <ProductDescription class="mb-3" :description="company.company.description" />
                                                      <div class="details__list__heading">Оформлення зеленої карти</div>
                                                      <ul>
                                                        <li>Тип полісу: Електронний</li>
                                                        <li>Варіанти оплати: Банківська картка, LiqPay</li>
                                                        <li>Доставка полісу: Відправляємо на імейл та/або вайбер після реєстрації договору в базі МТСБУ</li>
                                                        <li>Вигідна ціна: Вартість полісу фіксована для країн Європи</li>
                                                      </ul>
                                                    </div>
                                                    <table class="table">
                                                        <thead>
                                                        <tr>
                                                            <th scope="col">Основне покриття</th>
                                                            <th class="w-25" scope="col">Сума покриття</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(program, pindex) in programs" :key="pindex">
                                                            <td>
                                                                <div class="ui-option"
                                                                     :class="{'negative': company.programs.find(item => item.code === program.code) === undefined}">
                                                                    <div style="margin: 0;">{{ program.description }}
                                                                        <div class="" data-tooltipped=""
                                                                             aria-describedby="tippy-tooltip-159"
                                                                             style="display: inline;"><span></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td class="ui-option-cost"
                                                                v-if="company.programs.find(item => item.code === program.code) !== undefined"
                                                            >
                                                                <span v-if="program.code === 'Cancellation'">
                                                                    {{
                                                                        company.priceTrip
                                                                    }} {{
                                                                        company.programs.find(item => item.code === program.code).limitCurrency | currencySign
                                                                    }}
                                                                </span>
                                                                <span v-else>
                                                                    {{
                                                                        company.programs.find(item => item.code === program.code).limit
                                                                    }} {{
                                                                        company.programs.find(item => item.code === program.code).limitCurrency | currencySign
                                                                    }}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 text-center">
                            <button class="result-list__scrolltop" @click="scrollTop"><span>Вгору</span></button>
                        </div>
                    </div>
                    <div v-if="!loadingFlag && !variants.length" style="margin-top: 40px; text-align: center;">За
                        запитом пропозицій не знайдено, змініть параметри пошуку.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.result__territory {
  display: block;
  font-size: 12px;
  color: #6c757d;
  margin-top: 2px;
}

.nice-select .list {
    width: 300%;
}
</style>
<style scoped lang="scss">
.result-search {
    padding-top: 30px;
}

.tourism-searchpanel {
    cursor: pointer;
    border-radius: 3px;
    border: 1px solid #DDE2E5;
    width: 100%;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #24282C;
    font-weight: bold;
    font-size: 18px;
    height: 40px;
    margin-bottom: 28px;
    text-decoration: none;
    outline: none;

    span {
        margin-right: 10px;
    }

    svg {
        transition: all .3s;

        &.arrowUp {
            transform: rotate(180deg);
        }
    }
}

.transition-search-form-enter-active, .transition-search-form-leave-active {
    transition: all .3s ease
}

.transition-search-form-enter, .transition-search-form-leave-to {
    transform: translateY(-20px);
    z-index: -1;
    opacity: 0;
}

.errors {
    color: red;
}

.has_error {
    border-color: red;
}

.selectors.tourism-select .results .result-item .result-item__logo img {
    max-width: 80%;
    max-height: 35px;
    height: auto;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
}

input[type="number"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.result-list.new-list.flight-list .details__list ul {
    max-width: 100%;
}

.table td, .table th {
    border: 0;
    padding: 0.05rem;
}

.ui-option {
    position: relative;
    display: inline-flex;
    margin-right: 25px;
    padding-left: 20px;
}

.ui-option.negative, .ui-option-cost.negative {
    color: #999DA6;
}

.ui-option:before {
    position: absolute;
    left: 0;
    top: 4px;
    content: '';
    -webkit-mask: url(/img/icons/tourism_bullet.svg) no-repeat;
    mask: url(/img/icons/tourism_bullet.svg) no-repeat;
    background-color: #3cb12e;
    width: 14px;
    height: 11px;
}

.ui-option.negative:before {
    position: absolute;
    left: 0;
    top: 4px;
    content: '';
    -webkit-mask: url(/img/icons/tourism_bullet2.svg) no-repeat;
    mask: url(/img/icons/tourism_bullet2.svg) no-repeat;
    background-color: #999DA6;
    width: 14px;
    height: 11px;
}
</style>
<script>
import axios from "axios";
import Multiselect from 'vue-multiselect'
import TourismSearchForm from "@/views/tourism/components/TourismSearchForm";
import TourismPolicy from '@/components/app/tourism/TourismPolicy.vue';
import ClientPropositionInfo from '@/components/app/osago/ClientPropositionInfo.vue';
import userSettings from "@/mixin/userSettings";
import displaySettings from '@/mixin/displaySettings';
import {orderTourism} from "@/api/orderTourism";
import ModalDiscountSet from "@/components/app/modals/modal-discount-set.vue";
import { discountMixin } from '@/mixin/discountMixin';
import { ProductDescription } from '@/shared/ui/insurance';

export default {
    name: 'tourismResults',
    components: {
        ModalDiscountSet,
        Multiselect,
        TourismSearchForm,
        TourismPolicy,
        ClientPropositionInfo,
        ProductDescription
    },
    data: function () {
        return {
            clientPropositionsList: [],
            showPropositionModal: false,
            loadingFlag: false,
            concludeOffer: false,
            showTourismSearchForm: false,
            offerInfo: null,
            // searchInfo: null,
            step: 'result',
            touristCount: null,
            focusedPriceDiapason: false,
            items: [],
            //TODO need refactoring dynamic
            purposeOfTrip: [

                {id: "travel", name: "Подорож"},
                {id: "activeTravel", name: "Активний відпочинок"},
                {id: "sport", name: "Спорт"},
                {id: "work", name: "Робота"},
                {id: "teaching", name: "Навчання"},
                // {id: "prof_sport", name: "Професійний спорт"},
                {id: "extrim", name: "Екстремальний туризм"},
                {id: "business_travel", name: "Бізнес поїздка"},
                // {id: "active_sport", name: "Активний спортивний відпочинок"},
                // {id: "danger_work", name: "Небезпечна робота"},
            ],
            sortFilters: {
                limits: [],
                franchises: [],
                companies: [],
                purposeOfTrip: null,
                programs: [],
                priceDiapason: {min: '', max: ''},
                priceMin: '',
                priceMax: '',
                sort: "all",
                type: "lowcost",
            },
            insurance: null,
            activeClassWrapp: "",
            showEarnings: false,
            watchDefaultOffersSortType: null,
            TouristsList: [],
            payer: {
                identificationCode: null,
                erdpyCode: null,
                withoutDocuments: false,
                name: null,
                surname: null,
                dateBirth: false,
                phone: null,
                mail: null,
                city: null,
                street: null,
                house: null,
                apartment: null,
                documentType: 2,
                passportSerial: null,
                passportNumber: null,
                passportDate: null,
                withoutIdentificationCode: false,
                documentation: {
                    //TODO текущее значение нобходимо будет брать с словаря(api)

                    type: 2,//'DOCUMENT_EXTERNAL_PASSPORT'
                    serial: null,
                    number: null,
                    issuedBy: null,
                    dateOfIssue: null,
                    endDateOfIssue: null,
                    dateOfIssueError: false,
                    documentType: null,
                },
            },
        };
    },
    created: function () {
        this.updatePurposeOfTrip();
        this.getTourismOffers();
        this.watchDefaultOffersSortType = this.$watch('defaultOffersSortType', function (value) {
            this.sortFilters.type = value
            $(".nice-select").niceSelect('update')
            this.watchDefaultOffersSortType();
        })
        this.$store.commit('SET_CLIENT', null);
    },
    mounted: function () {
        $(".nice-select").niceSelect();
    },
    watch: {
        showTourismSearchForm: function () {
            if (!this.showTourismSearchForm) {
                this.getTourismOffers()
            }
        },
    },
    computed: {
        user() {
          return this.$store.getters.USER;
        },
        isApiUser() {
          return this.user && Number(this.user.type_id) === 5;
        },
        searchInfo() {
          return this.$store.getters.GET_SEARH_TOURISM_PARAMS
        },
        programs: function () {
            let result = [];
            let returnArray = [];
            _.forEach(this.items, (item) => {
                _.forEach(item.programs, (program) => {
                    result.push(program);
                })
            })
            let uniq = _.uniq(_.map(result, 'code'));
            _.map(result, (program) => {
                if (uniq.includes(program.code)) {
                    returnArray.push(program);
                    uniq = _.remove(uniq, function (code) {
                        return code !== program.code;
                    })
                }
            })
            return returnArray;
        },
        companies: function () {
            let result = [];
            let returnArray = [];
            _.forEach(this.items, (item) => {
                let company = {id: item.company.id, name: item.company.publicName}
                result.push(company);
            })
            let uniq = _.uniq(_.map(result, 'id'));
            result = _.map(result, (company) => {
                if (uniq.includes(company.id)) {
                    returnArray.push(company);
                    uniq = _.remove(uniq, function (id) {
                        return id !== company.id;
                    })
                }
            })
            return returnArray;
        },
        limits: function () {
            let result = [];
            let returnArray = [];
            _.forEach(this.items, (item) => {
                result.push({id: item.limit, name: item.coverage});

            })
            let uniq = _.uniq(_.map(result, 'id'));
            result = _.map(result, (member) => {
                if (uniq.includes(member.id)) {
                    returnArray.push(member);
                    uniq = _.remove(uniq, function (id) {
                        return id !== member.id;
                    })
                }
            })

            return returnArray
        },
        franchises: function () {
            let result = [];
            let returnArray = [];
            _.forEach(this.items, (item) => {
                result.push({id: item.franchise, name: item.franchise});

            })

            let uniq = _.uniq(_.map(result, 'id'));
            result = _.map(result, (member) => {
                if (uniq.includes(member.id)) {
                    returnArray.push(member);
                    uniq = _.remove(uniq, function (id) {
                        return id !== member.id;
                    })
                }
            })

            return returnArray

        },
        variants: function () {
            let result = this.items;
            if (this.sortFilters.priceDiapason.min > 0) {
                result = result.filter(item => {
                    return item.price >= this.sortFilters.priceDiapason.min;
                });
            }
            if (this.sortFilters.priceDiapason.max > 0) {
                result = result.filter(item => {
                    return item.price <= this.sortFilters.priceDiapason.max;
                });
            }
            if (this.sortFilters.companies.length > 0) {
                let ids = _.map(this.sortFilters.companies, 'id');
                result = result.filter(item => {
                    return ids.includes(item.company.id)
                });
            }

            if (this.sortFilters.purposeOfTrip && this.sortFilters.purposeOfTrip.id) {
                let id = this.sortFilters.purposeOfTrip.id;
                result = result.filter(item => {
                    return _.map(item.members, 'code').includes(id);
                });
            }
            if (this.sortFilters.limits.length > 0) {
                let ids = _.map(this.sortFilters.limits, 'id');
                result = result.filter(item => {
                    return ids.includes(item.limit)
                });
            }
            if (this.sortFilters.programs.length > 0) {
                let filterCodes = _.map(this.sortFilters.programs, 'code')
                result = result.filter(item => {
                    let codes = _.map(item.programs, 'code');
                    let flag = false;
                    let count = 0;
                    _.forEach(codes, (code) => {
                        if (filterCodes.includes(code)) {
                            count++
                        }
                    })
                    if (count === filterCodes.length) {
                        flag = true
                    }
                    return flag;
                });
            }
            if (this.sortFilters.franchises.length > 0) {

                let franchiseIds = _.map(this.sortFilters.franchises, 'id');

                result = result.filter(item => {
                    return franchiseIds.includes(item.franchise)
                });
            }
            switch (this.sortFilters.type) {
                case "name":
                    result = result.sort(function (a, b) {
                        return (a.company.publicName || '').localeCompare(b.company.publicName || '', 'uk');
                    });
                    break;
                case "earnings":
                    result = result.sort(function (a, b) {
                        if (a.earnings > b.earnings) {
                            return -1;
                        }
                        if (b.earnings > a.earnings) {
                            return 1;
                        }
                        return 0;
                    });
                    break;
                case "lowcost":
                    result = result.sort(function (a, b) {
                        if (a.price < b.price) {
                            return -1;
                        }
                        if (b.price < a.price) {
                            return 1;
                        }
                        return 0;
                    });
                    break;
                case "price-earnings":
                    result = result.sort(function (a, b) {
                        if (Math.round((a.earnings / a.price) * 100) > Math.round((b.earnings / b.price) * 100)) {
                            return -1;
                        }
                        if (Math.round((b.earnings / b.price) * 100) > Math.round((a.earnings / a.price) * 100)) {
                            return 1;
                        }
                        return 0;
                    });
                    break;
                case "net-pay":
                    result = result.sort(function (a, b) {
                        const aNetPay = a.discountPrice > 0 ? a.discountPrice - a.earnings : a.price - a.earnings;
                        const bNetPay = b.discountPrice > 0 ? b.discountPrice - b.earnings : b.price - b.earnings;

                        if (aNetPay > bNetPay) {
                            return 1;
                        }

                        if (aNetPay < bNetPay) {
                            return -1;
                        }

                        return 0;
                    });
                    break;
                default:
                    result = result.sort(function (a, b) {
                        return (a.company.publicName || '').localeCompare(b.company.publicName || '', 'uk');
                    });
                    break;
            }
            return result;
        },
        orderData() {
            return this.$store.state.tourismStore.infoOffer;
        },
    },
    methods: {
        handleUpdateOffer(updatedOffer) {
            this.variants.forEach((offer) => {
                this.$set(offer, 'showModal', false)
                if (offer.offerId === updatedOffer.offerId) {
                    if (parseFloat(updatedOffer.price) > parseFloat(updatedOffer.discountPrice)) {
                        const dynamicDiscountPrice = updatedOffer.discountPrice;
                        this.$set(offer, "dynamicDiscountPrice", +parseFloat(dynamicDiscountPrice).toFixed(2));
                        this.$set(offer, "dynamicDiscountPercent", +parseFloat(updatedOffer.discountPercent).toFixed(2));
                        this.$set(offer, "dynamicDiscountedSum", +parseFloat(updatedOffer.discountedSum).toFixed(2));
                        this.$set(offer, "dynamicEarnings", +parseFloat(updatedOffer.earnings).toFixed(2));
                    } else if (parseFloat(updatedOffer.discountPrice) >= 0) {
                        this.$set(offer, "dynamicDiscountPrice", 0);
                        this.$set(offer, "dynamicDiscountPercent", 0);
                        this.$set(offer, "dynamicDiscountedSum", 0);
                        this.$set(offer, "dynamicEarnings", 0);
                    }
                }
            });
        },
        discountSet(event, offer) {
            this.$set(offer, "showModal", !offer.showModal);
        },
        changeQuery(value) {
            this.$router.replace({path: this.$router.path, query: {purposeOfTrip: value}})
        },
        purposeOfTripOptionSelected(option) {
            this.changeQuery(option.id);
        },
        getTripProgram(TripProgram) {
            const Trips = {
                'econom': 'економ',
                'standart': 'стандарт',
                'elit': 'еліт'
            };
            return Trips[TripProgram] ?? TripProgram;
        },
        updateparent(variable) {
            this.showTourismSearchForm = variable
        },
        scrollTop: function () {
            $('html,body').stop().animate({
                scrollTop: 0
            }, 'slow', 'swing');
        },
        concludeContract(offer) {
            offer.purposeOfTrip = (this.sortFilters.purposeOfTrip && this.sortFilters.purposeOfTrip.id) || 'travel';
            offer.oldPrice = null;
            offer.prolongOrderId = this?.orderData?.prolongOrderId;

            this.submitHandler(offer);
        },
        concludeContractSend(offer) {
            this.$store.commit('SET_TOURISM_INFO_OFFER', offer);
            if (this.$route.query?.from !== 'prolongation' && this.$route.query?.from !== 'history') {
                this.$store.commit('CLEAR_TOURISM_INFO_USER');
                this.$store.commit('CLEAR_TOURISM_INFO_TOURISTSLIST');
                //this.$store.commit('CLEAR_TOURISM_FULL_ORDER');
            }
            this.$store.commit('CLEAR_TOURISM_CONTRACT_ID');
            this.$router.push('/tourism-steps').catch(() => {
                this.$router.push('/tourism-steps');
            });

        },
        submitHandler(offer) {
            this.concludeOffer = true;
            this.TouristsList = [];
            offer.allowed_documents = offer.available_documents ?? offer.allowed_documents;
            offer.fullPrice = offer.price;
            offer.orderDraft = 1; // флаг создания нового полиса для исключения валидации

            if (offer.dynamicDiscountedSum > 0) {
                offer.discountDetails = {
                    dynamicDiscountPrice: offer.dynamicDiscountPrice,
                    dynamicDiscountPercent: offer.dynamicDiscountPercent,
                    dynamicDiscountedSum: offer.dynamicDiscountedSum,
                    dynamicEarnings: offer.dynamicEarnings,
                    earnings: offer.earnings
                };
            } else {
                offer.discountDetails = null;
            }

            let params = {
                type: 'next',
                statusId: -1, //статус нового ордера
            };

            this.$store.commit('SET_TOURISM_INFO_OFFER', offer);
            if (this.$route.query?.from !== 'prolongation' && this.$route.query?.from !== 'history') {
                this.$store.commit('SET_TOURISM_INFO_USER', this.payer);
                this.$store.commit('SET_TOURISM_INFO_TOURISTSLIST', this.TouristsList);
            }

            orderTourism(offer, this.searchInfo, this.payer, this.TouristsList, this.orderId, params).then((response) => {
                this.$store.commit('CLEAR_TOURISM_FULL_ORDER');
                if (response?.data.message === "OK" && response?.data?.data[0]?.id) {
                    this.orderId = response?.data?.data[0]?.id;
                    this.$store.commit('SET_TOURISM_FULL_ORDER', response.data.data[0].id);
                    this.concludeContractSend(offer);
                    this.concludeOffer = false;
                } else {
                    this.$alert('Помилка створення замовлення. Спробуйте ще раз.', '', 'error');
                    this.concludeOffer = false;
                }
            }).catch((error) => {
                console.error(error);
                this.$alert('Щось пішло не так. Перевірте заповнені поля.');
                this.concludeOffer = false;
            });
        },
        is_checkedLimits(limits) {
            let ids = _.map(this.sortFilters.limits, 'id');
            return ids.includes(limits.id);
        },
        is_checkedCompany(company) {
            let ids = _.map(this.sortFilters.companies, 'id')
            return ids.includes(company.id);
        },
        is_checkedProgram(program) {
            let codes = _.map(this.sortFilters.programs, 'code')
            return codes.includes(program.code);
        },
        is_checkedFranchises(franchise) {
            return this.sortFilters.franchises.includes(franchise);
        },
        removeClientProposition(value) {
            const index = this.clientPropositionsList.indexOf(value);
            if (index !== -1) {
                this.clientPropositionsList.splice(index, 1);
            }
        },
        clearPropositions() {
            this.clientPropositionsList = [];
        },
        selectClientProposition(event, value) {
            const index = this.clientPropositionsList.indexOf(value);
            if (index === -1) {
                this.clientPropositionsList.push(value);
                this.showPropositionModal = true;
            } else {
                this.clientPropositionsList.splice(index, 1);
            }
        },
        updatePurposeOfTrip() {
            this.sortFilters.purposeOfTrip = this.purposeOfTrip.find(option => {
              if (this.$route.query.purposeOfTrip) {
                return option.id === this.$route.query.purposeOfTrip
              }

              return option.id === 'travel'
            });
        },
        filterDiscard() {
            this.sortFilters = {
                companies: [],
                purposeOfTrip: null,
                programs: [],
                limits: [],
                franchises: [],
                priceDiapason: {min: '', max: ''},
                priceMin: '',
                priceMax: '',
                sort: "all",
                type: "lowcost",
            }
        },
        async getSearchParams(params) {
            this.loadingFlag = true;
            this.items = [];
            this.touristCount = params.tourists
            this.sortFilters = {
                companies: [],
                purposeOfTrip: null,
                programs: [],
                limits: [],
                franchises: [],
                priceDiapason: {min: '', max: ''},
                priceMin: '',
                priceMax: '',
                sort: "all",
                type: "price-earnings",
            }

            this.updatePurposeOfTrip();
            try {
                const {data: {data}} = await axios.post('/api/' + process.env.VUE_APP_SERVER_MODE + '/insurance/calculator/tourism', params);
                this.items = (data || []).map(offer => ({
                    ...offer,
                    startEarnings: Number(offer.earnings),
                    startPrice: Number(offer.price)
                }));
                this.loadingFlag = false;
            } catch (error) {
                /*this.errors.clear();
                let errors = error.response.data.errors;
                for (var prop in errors) {
                    this.errors.add({field: prop, msg: errors[prop][0]});
                }*/
                this.loadingFlag = false;
            }
        },
        getTourismOffers() {
            const params = this.$store.getters.GET_SEARH_TOURISM_PARAMS;
            if (params) {
                if (this.sortFilters.purposeOfTrip && this.sortFilters.purposeOfTrip.id) {
                    params.purposeOfTrip = this.sortFilters.purposeOfTrip.id;
                }
                this.getSearchParams(params);
            } else {
                this.$router.push({name: `search-tourism`});
            }

            if (params) {
                params.tourists = params.birthDates.length;
                this.$store.commit('SET_SEARCH_TOURISM_PARAMS', params);
            }
        },
        filterStatusWrapp() {
            this.activeClassWrapp = !this.activeClassWrapp;

            if (this.activeClassWrapp) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }

        },
        viewSecondAdd(view) {
            document.querySelector('.toggler-view-default').classList.remove('active');
            document.querySelector('.toggler-view-second').classList.add('active');
            document.querySelector('.result-list').classList.add(view);
        },
        viewSecondRemove(view) {
            document.querySelector('.toggler-view-second').classList.remove('active');
            document.querySelector('.toggler-view-default').classList.add('active');
            document.querySelector('.result-list').classList.remove(view);
        },
    },
    mixins: [userSettings, displaySettings, discountMixin],
}
</script>
